<template>
<div>

    <v-data-table 
        :loading="loading"
        :search="search"
        disable-initial-sort
        :rows-per-page-items="rowPerPage"
        :headers="headers"
        :items="filtered_items"
        item-key="id">
        <template #headers="props">
            <tr>
                <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                </th>
            </tr>
        </template>
        <template #items="props">
            <tr>
                <td class="text-no-wrap">
                    <v-menu offset-y>
                        <v-btn icon slot="activator">
                            <v-icon small color="#464D69">settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile
                                @click="triggerDialog(props.item, 'edit')"
                            >
                                <v-list-tile-action>
                                    <v-icon small class="zmdi zmdi-edit"></v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    Chỉnh sửa
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
                <td class="text-left text-no-wrap">{{ props.item.receipt_id }}</td>
                <td class="text-left text-no-wrap">{{ props.item.type_text }}</td>
                <td class="text-right text-no-wrap">{{ props.item.amount | formatNumber }}</td>
                <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                <td class="text-center text-no-wrap">{{ props.item.receiver }}</td>
                <td class="text-center text-no-wrap">{{ props.item.wallet_account_id | translateWalletName }}</td>
                <td class="text-center text-no-wrap">{{ props.item.date_created | formatTimeServer }}</td>
                <td class="text-left text-no-wrap">{{ props.item.note }}</td>
                <td class="text-right text-no-wrap">{{ props.item.diff_return_deposit | formatNumber }}</td>
                <td class="text-center text-no-wrap">{{ props.item.check_out_id }}</td>
            </tr>
        </template>
        <template #no-data>
            Chưa có thông tin
        </template>
    </v-data-table>
    <edit-phieu-chi
        :chosen_receipt="chosen_receipt"
        :dialog="trigger_edit_component"
        @changeDialogState="trigger_edit_component = $event"
        @reloadTable="getData"
    >
    </edit-phieu-chi>
</div>
</template>

<script>

import api from '../../api';
import { buildParamQuery } from '../../helpers/helpers';
import EditPhieuChi from './EditPhieuChi';

export default {
    name: "table-phieu-chi",
    props: {
        reload_table: Number,
        loader: Boolean,
        date_start: String,
        date_end: String,
        search: String,
        chosen_receiver: String
    },
    components: {
        EditPhieuChi
    },
    data(){
        return {
            items: [],
            loading: false,
            headers: [
                { text: "Thao tác", align: "center", sortable: false },
                {text: "#Chứng từ", align: "left", sortable: true, value: "receipt_id"},
                {text: "Loại chi", align: "left", sortable: true, value: "type_text"},
                {text: "Số tiền", align: "right", sortable: true, value: "amount"},
                {text: "Số phòng", align: "center", sortable: true, value: "room_id"},
                {text: "Người nhận", align: "center", sortable: true, value: "receiver"},
                {text: "Hình thức chi", align: "center", sortable: true, value: "wallet_account_id"},
                {text: "Ngày tạo", align: "center", sortable: true, value: "date_created"},
                {text: "Ghi chú", align: "left", sortable: false, value: "note"},
                {text: "Chênh lệch tiền trả cọc", align: "right", sortable: true, value: "diff_return_deposit"},
                {text: "Mã phiếu trả phòng", align: "center", sortable: true, value: "check_out_id"}
            ],
            rowPerPage: [50, 100, 200, {"text":"Tất cả","value":-1}],
            list_disbursement_type: [
                { text: "Chi trả cọc", value: "return_deposit" },
                { text: "Chi hoa hồng", value: "commission"},
                { text: "Chi lương", value: "employee_wage"},
                { text: "Chi khác", value: "other"}
            ],
            chosen_receipt: {},
            trigger_edit_component: false
        }
    },
    computed: {
        filtered_items(){
            return this.items.filter(item => {
                if (this.chosen_receiver == "Tất cả")
                    return true
                else if (this.chosen_receiver && item.receiver == this.chosen_receiver)
                    return true
                return false
            })
        }
    },
    watch: {
        reload_table(){
            this.getData()
        },
        loading(nv){
            this.$emit("update:loader", nv)
        }
    },
    methods: {
        getData: async function (){
            this.items = []
            this.loading = true;
            const params = {
                dateStart: this.date_start,
                dateEnd: this.date_end
            }
            const query = buildParamQuery(params)
            let data = await api.getDisbursementReceipt(query)
            this.loading = false;
            if (data.status === 200) {
                this.items = data.data.map(item => {
                    const found_type = this.list_disbursement_type.find( type => type.value === item.type)
                    item.type_text = found_type.text
                    if (item.type == "return_deposit" && item.return_deposit_amount !== undefined){
                        item.diff_return_deposit = item.amount - item.return_deposit_amount
                    }
                    return item
                })
            } else {
                console.log('Lỗi lúc tải phiếu chi');
            }
        },
        openDialog(internet_user, action){
            if (action === 'change') this.change_room_id_dialog = true;
            else if (action === 'activate') this.activate_internet_dialog = true;
            else if (action === "cancel") this.cancel_internet_dialog = true;
            this.chosen_internet_user = internet_user;
        },
        updateInternetUser(internet_user){
            const selected_user = this.items.find(user => user._id === internet_user._id);
            for (const key in selected_user) {
                if (selected_user.hasOwnProperty(key)) {
                    const element = internet_user[key];
                    selected_user[key] = element;
                }
            }
        },
        triggerDialog: function (receipt, type){
            this.chosen_receipt = receipt;
            if (type === 'edit') this.trigger_edit_component = !this.trigger_edit_component
        }
    }
}
</script>

<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
</style>